// eslint-disable-next-line import/prefer-default-export
export function sortContacts(contacts) {
  return contacts.sort((a, b) => {
    // Comparar por freshness descendente
    if (b.freshness !== a.freshness) {
      return b.freshness - a.freshness;
    }
    // Si freshness es igual, comparar por id ascendente
    return a.id - b.id;
  });
}
